import { useCallback } from 'react';
import useStyle from '../styles/rowStatusStyles';
import { Cell } from 'react-table';
import { EStatus } from '../types/enums/EStatus';

const usePromocodesPanelStyles = () => {
  const style = useStyle();

  const tableStyleHandler = useCallback(
    (cell: Cell<any, any>) => {
      if (cell.column.id === 'image') {
        return `${style.cellSize} ${style.imageCell}`;
      }
      if (
        (cell.column.id === 'status' && (cell.value === EStatus.Active || cell.value === EStatus.Valid)) ||
        cell.value === EStatus.New
      ) {
        return `${style.cellSize} ${style.statusStyle}`;
      }
      if (cell.row.values['status'] === EStatus.Inactive || cell.row.values['status'] === EStatus.Used) {
        return `${style.cellSize} ${style.inactiveRow}`;
      }
    },
    [style.inactiveRow, style.statusStyle],
  );

  return tableStyleHandler;
};

export default usePromocodesPanelStyles;
